// Display the actual pineapple from the supplied logo without altering the original asset.
export const PineappleIcon = ({ className = "h-8 w-8" }) => (
  <svg viewBox="596 535 150 258" className={className} aria-hidden="true" style={{ overflow: "hidden", borderRadius: "8px" }}>
    <image href="/assets/lobang-logo.jpg" width="1254" height="1254" />
  </svg>
);
